var firebase = require('../firebase');
var fetch = require('isomorphic-fetch');
var databaseURL = "https://ajato-29abc.firebaseio.com"; //Produção
//var databaseURL = "https://ajato-e2d54.firebaseio.com"; //Teste

var { fbDb } = firebase;

module.exports = {
	fetching: function() {
		return {
			type: "DATA_FETCHING"
		};
	},

	fetched: function() {
		return {
			type: "DATA_FETCHED"
		};
	},

	loadMyOrders: function(orders) {
		return {
			type: "LOAD_MYORDERS",
			payload: orders
		};
	},

	createMyOrder: function(order) {
		return {
			type: "CREATE_MYORDER",
			payload: order
		};
	},

	updateMyOrder: function(order) {
		return {
			type: "UPDATE_MYORDER",
			payload: order
		};
	},

	deleteMyOrder: function(order) {
		return {
			type: "DELETE_MYORDER",
			payload: order
		};
	},

	filterMyOrders: function(type) {
		return {
			type: "FILTER_MYORDERS",
			payload: type
		};
	},

	unloadMyOrders: function() {
		return {
			type: "UNLOAD_MYORDERS"
		};
	},

	orderFetching: function() {
		return {
			type: "ORDER_FETCHING"
		}
	},

	loadSpecific: function(order) {
		return {
			type: "LOAD_SPECIFIC_ORDER",
			payload: order
		};
	},

	unloadSpecific: function() {
		return {
			type: "UNLOAD_SPECIFIC_ORDER"
		};
	},

	loadSpecificOrder: function(key) {
		var me = this, endpoint = databaseURL + '/orders/' + key;
				
		return function(dispatch) {
			fetch(endpoint + '.json')
			.then(function(response) {
				if (response.status >= 400)
					throw new Error("Bad response from server");
				return response.json();

			}).then(function(order) {
				order.key = key;
				dispatch(me.loadSpecific([order]));
			});

			//dispatch(me.orderFetching());
		}
	},

	unwrapOrder: function(order, key) {
		return Object.assign({}, order, {
			key: key
		});
	},

	subscribe: function(uid) {
		var me = this;
		
		return function(dispatch) {
			var ref = fbDb.ref('users/' + uid + '/myOrders'),
				list = [],
				initialized = false;

			ref.once('value', (orders) => {
				initialized = true;
				dispatch(me.loadMyOrders(list));
			});

			ref.on('child_added', snap => {
				var order = me.unwrapOrder(snap.val(), snap.key);

				if (initialized)
					dispatch(me.createMyOrder(order));
				else
					list.push(order);
			});

			ref.on('child_changed', snap => {
				var order = me.unwrapOrder(snap.val(), snap.key);

				dispatch(me.updateMyOrder(order))
			});

			ref.on('child_removed', snap => {
				dispatch(me.deleteMyOrder(snap.key));
			});

			me._unsubscribe = () => ref.off();

			dispatch(me.fetching());
		};
	},

	unsubscribe: function() {
		var me = this;

		return function(dispatch) {
			me._unsubscribe();
			
			dispatch(me.unloadMyOrders());
		};
	}
};


// WEBPACK FOOTER //
// ./src/actions/myOrdersActions.js